module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "far fa-check-circle customCheck"
  }), _vm._v(" "), _c('h2', {
    staticClass: "p-2 font-weight-bold"
  }, [_vm._v("¡Se ha restablecido la contraseña!")]), _vm._v(" "), _c('p', {
    staticClass: "px-4"
  }, [_vm._v("Aute officia eiusmod Lorem eiusmod sint duis laborum do non. Fugiat Lorem ad irure enim dolore aute magna qui enim qui do fugiat aute ex. Eiusmod et officia excepteur est.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-886e5094"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordConfirm.vue
// module id = 1899
// module chunks = 1